import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status?: ReduxStateType;
  data?: any[];
}

const initialState: InitialState = {
  status: ReduxStateType.INIT,
  data: [],
};

const getListCandidateCampaignSlice = createSlice({
  name: "getListCandidateCampaign",
  initialState,
  reducers: {
    getListCandidateCampaignStart: (
      state,
      action: PayloadAction<{ screenCode: string }>
    ) => {
      state.status = ReduxStateType.LOADING;
    },
    getListCandidateCampaignSuccess: (
      state,
      action: PayloadAction<{
        data: any[];
      }>
    ) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = [...(state.data ?? []), ...action.payload.data];
    },
    getListCandidateCampaignFailed: (state) => {
      state.status = ReduxStateType.ERROR;
      state.data = [];
    },
    resetListCandidateCampaign: () => initialState,
  },
});

export const {
  getListCandidateCampaignStart,
  getListCandidateCampaignSuccess,
  getListCandidateCampaignFailed,
  resetListCandidateCampaign,
} = getListCandidateCampaignSlice.actions;
export default getListCandidateCampaignSlice.reducer;
